import { css } from 'styled-components';

export const Checkbox = css`
  position: relative;
  display: block;
  width: 100%;
`;

export const Check = css`
  display: inline-block;
  position: relative;
  color: ${(props) => props.theme.color};
  font-size: 19px;
  font-weight: 400;
  padding-left: 35px;
  cursor: pointer;

  &:before {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 0px;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    transform: translate(0, -50%);
    background: ${(props) => props.theme.background};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 4px;
    outline: none;
    transition: 0.2s all;
    content: '';

    ${(props) =>
      props.valid &&
      css`
        border: 1px solid ${(props) => props.theme.borderColorOnValid};
      `};

    ${(props) =>
      props.invalid &&
      css`
        border: 1px solid ${(props) => props.theme.borderColorOnInvalid};
      `};

    ${(props) =>
      props.checked &&
      css`
        color: ${(props) => props.theme.iconColor};
        font-family: 'Material Icons';
        content: '\\e5ca';
        font-size: 22px;
        font-weight: 700;
        line-height: 1;
        text-align: center;
      `}

    ${(props) =>
      props.disabled &&
      css`
        opacity: 0.35;
      `};
  }
`;

export const Checkmark = css`
  display: none;
`;
